export enum MakeCurrentButtonView {
    DealComparison = 'btn-make-current-deal-comparison',
    DealHistory = 'btn-make-current-deal-history',
    QuickCompare = 'btn-make-current-quick-compare'
}
